"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _ArticleEditListItem = _interopRequireDefault(require("./ArticleEditListItem"));

var ArticleEditList = function ArticleEditList(_ref) {
  var edits = _ref.edits,
      latestEdit = _ref.latestEdit,
      selectedEdit = _ref.selectedEdit,
      onItemClicked = _ref.onItemClicked;
  return (0, _preact.h)("div", {
    className: "article-versions__edit-list"
  }, Object.entries(edits).map(function (edit) {
    var groupName = edit[0];
    var editList = edit[1];
    return editList.length > 0 && (0, _preact.h)("div", null, (0, _preact.h)("div", {
      className: "article-versions__edit-list-group"
    }, groupName), editList.map(function (edit) {
      return (0, _preact.h)(_ArticleEditListItem.default, {
        editedAt: edit.edited_at,
        editedBy: edit.edited_by,
        isLatest: edit.edited_at === latestEdit,
        isSelected: edit.edited_at === selectedEdit,
        onClick: onItemClicked,
        key: "article-".concat(edit.edited_at)
      });
    }));
  }));
};

var _default = ArticleEditList;
exports.default = _default;